export default {
    name: null,
    show_components_amount_on_pdf: null,
};
